import { Typography } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';

const { Text } = Typography;

interface IAuthSwitchLink {
  // e.g. "Don't have an account?"
  question: string;
  // e.g. "Sign up for free"
  ctaLabel: string;
  to: string;
  onClick?: () => void;
  wrapperClass?: string;
}

const AuthSwitchLink: React.FC<IAuthSwitchLink> = ({
  question,
  ctaLabel,
  to,
  onClick,
  wrapperClass,
}) => (
  <Text
    className={classNames(
      'tw-flex tw-flex-wrap tw-justify-center tw-gap-1 tw-text-[14px]',
      wrapperClass,
    )}
  >
    {question}
    <Link
      to={to}
      onClick={onClick}
      className="!tw-text-[var(--color-secondary)] tw-font-semibold hover:tw-underline"
    >
      {ctaLabel}
    </Link>
  </Text>
);

export default AuthSwitchLink;
